import { BANNER_CAMPAIGNS, SUPPRESSED, BANNER_FEATURE_ACTIVE } from './banners/campaigns';
import { resolveBanners } from './banners/rules';
import type { BannerContext } from './banners/types';

export const MARKETING_BANNER_HEIGHT_PX = 32;
/** Mobile `<header>` bar height (Header.module.css .barInner, <900px). */
export const HEADER_BAR_HEIGHT_PX = 44;
/** Desktop `<header>` bar height (Header.module.css .barInner, ≥900px). */
export const DESKTOP_BAR_HEIGHT_PX = 56;
/** Top margin GSAP gives the scrolled floating pill (tweenPill). */
export const PILL_TOP_MARGIN_PX = 12;
export const MARKETING_BANNER_HEIGHT_VAR = '--uh-marketing-banner-height';
export const HEADER_STACK_HEIGHT_VAR = '--uh-header-stack-height';

/** Same resolver the banner renders from, so height and content cannot disagree. */
export const isMarketingBannerVisible = (ctx: BannerContext): boolean =>
  resolveBanners(ctx, BANNER_CAMPAIGNS, SUPPRESSED).length > 0;

export const getMarketingBannerHeightPx = (ctx: BannerContext): number =>
  isMarketingBannerVisible(ctx) ? MARKETING_BANNER_HEIGHT_PX : 0;

export const getHeaderStackHeightPx = (ctx: BannerContext): number =>
  HEADER_BAR_HEIGHT_PX + getMarketingBannerHeightPx(ctx);

export const isMarketingBannerActive = (): boolean => BANNER_FEATURE_ACTIVE;

export function applyMarketingBannerCssVars(bannerHeightPx: number): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty(MARKETING_BANNER_HEIGHT_VAR, `${bannerHeightPx}px`);
  root.style.setProperty(
    HEADER_STACK_HEIGHT_VAR,
    `${HEADER_BAR_HEIGHT_PX + bannerHeightPx}px`,
  );
}
